import {
    GA_COMPONENT_CSS_ATTRIBUTE_NAME,
    GA_COMPONENT_UNKNOWN_COMPONENT_VALUE,
} from '~shared/utils/google-analytics';
import {
    SELECTION_CLASS,
    SELECTION_SELECTED_CLASS,
} from './constants';

import {
    addSelectionToBetslip,
    removeSelectionFromBetslip,
} from './interactions';

const clickHandler = (e) => {
    const { target } = e;

    if (!target.matches([SELECTION_CLASS, SELECTION_SELECTED_CLASS].join(', .'))) {
        return;
    }

    const {
        selectionId,
        spectateProduct,
    } = target.dataset;
    const isSelected = target.classList.contains(SELECTION_SELECTED_CLASS);
    const betLocate = target
        .closest(`[${GA_COMPONENT_CSS_ATTRIBUTE_NAME}]`)
        ?.getAttribute(GA_COMPONENT_CSS_ATTRIBUTE_NAME)
        || GA_COMPONENT_UNKNOWN_COMPONENT_VALUE;
    if (spectateProduct) {
        const gtmEnd = (isSelected) ? 'add-to-bet-slip' : 'remove-from-bet-slip';
        const gtmStart = spectateProduct.split(';');
        gtmStart.pop();
        target.dataset.spectateProduct = `${gtmStart.join(';')};${gtmEnd}`;
    }

    target.dataset.testId = isSelected ? 'selection;add-to-bet-slip' : 'selection;selected';

    // if customer adds recommendation from receipt, we shouldn't move back to the betslip
    const isReceiptAdd = target.parentElement.parentElement.classList.contains('fullslip__recommendation-details');

    if (!isSelected) {
        const isScorecast = target.classList.contains('scorecast');

        addSelectionToBetslip(selectionId, { is_scorecast: isScorecast, bet_locate: betLocate }, isReceiptAdd);
    } else {
        removeSelectionFromBetslip(selectionId);
    }
};

document.body.addEventListener('click', clickHandler);
